var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83721 2C2.71798 2 1 3.72198 1 5.84615V8.92308C1 11.0472 2.71798 12.7692 4.83721 12.7692H9.18605V14.849C9.18605 17.9487 6.67907 20.4615 3.58656 20.4615C3.16272 20.4615 2.81912 20.8059 2.81912 21.2308C2.81912 21.6556 3.16272 22 3.58656 22C7.52677 22 10.7209 18.7984 10.7209 14.849V5.84615C10.7209 3.72198 9.00295 2 6.88372 2H4.83721Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1163 2C14.997 2 13.2791 3.72198 13.2791 5.84615V8.92308C13.2791 11.0472 14.997 12.7692 17.1163 12.7692H21.4651V14.849C21.4651 17.9487 18.9581 20.4615 15.8656 20.4615C15.4418 20.4615 15.0982 20.8059 15.0982 21.2308C15.0982 21.6556 15.4418 22 15.8656 22C19.8058 22 23 18.7984 23 14.849V5.84615C23 3.72198 21.282 2 19.1628 2H17.1163Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt);
export default __webpack_public_path__ + "static/media/quote-alt.b5b42913142098449be2b7dab4ab7012.svg";
export { ForwardRef as ReactComponent };